<script>
    export let url;
    export let width;
    export let height;
    export let style = "";
    export let maxWidth = 420;
</script>

<style>
    div.outer {
        margin: 0;
        display: inline-block;
        flex: 0 0 auto;
    }
    div.inner {
        background-size: cover;
        background-repeat: no-repeat;
    }
</style>

<div class="outer" style="width: min({maxWidth}px, 30vh, 100%); {style}">
    <div class="inner" style="padding-top: {100 / width * height}%; background-image: url({url})"/>
</div>